import { useQuery, UseQueryResult } from "react-query";
import { getActsLookup } from "services/acts";
import { ActsLookupItem } from "api/types";

/**
 * Charge la liste complète des actes en format léger
 * `{id, label, price, actsTypeName}` et la cache 30 min. Pensé pour
 * alimenter un combobox local (filtrage en mémoire) — y compris dans
 * l'onglet Bons où `price` / `actsTypeName` servent au calcul des
 * lignes de facture. Pour les pages d'administration du catalogue,
 * continuer d'utiliser {@link getActs} paginé.
 *
 * <p>Le `select` aplatit l'enveloppe `apiRequest` ({ok, status, data}) en
 * `ActsLookupItem[]` direct — le consommateur fait `useActsLookup().data`
 * sans double-unwrap.
 */
export function useActsLookup(): UseQueryResult<ActsLookupItem[]> {
  return useQuery<any, unknown, ActsLookupItem[]>(
    ["acts-lookup"],
    () => getActsLookup(),
    {
      staleTime: 30 * 60 * 1000,
      select: (result: any) => (result?.ok ? result.data ?? [] : []),
    }
  );
}

export default useActsLookup;
